import styled from 'styled-components'

export const ExternalModalProgramContainer = styled.div`
  display: grid;
  gap: 20px;
  margin-bottom: 66px;
`

export const ExternalModalScheduleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  position: relative;
`
export const ExternalModalScheduleItem = styled.div`
  margin: 4px;
  flex: 0 1 calc(20% - 8px);
`
